import React from 'react';

const HelpFullData = () => {
  const HelpData = [
    {
      name: "Ram lala aarti",
      img: "./Images/Events/ramlalaaarti.jpg",
      about: "Experience the serene atmosphere and spiritual devotion during the Ram Lala Aarti ceremony in Ayodhya, where devotees gather to offer prayers and hymns to Lord Rama.",
      wikiLink: "https://en.wikipedia.org/wiki/Ram_Mandir",
      VID: "_Arq_FTWXVI",
    },
    {
      name: "Hanuman Jayanti",
      img: "./Images/Events/Hanuman-Jayanti2.jpg",
      about: "Join the vibrant celebrations of Hanuman Jayanti in Ayodhya, honoring the birth of Lord Hanuman, an epitome of devotion and strength in Hinduism.",
      wikiLink: "https://en.wikipedia.org/wiki/Hanuman_Jayanti",
      VID: "DYLBe37dyw4",
    },
    {
      name: "Deepotsav",
      img: "./Images/Events/deeputsav.webp",
      about: "Experience the grandeur of Deepotsav, the festival of lights, in Ayodhya, commemorating the return of Lord Rama to Ayodhya after his victory over Ravana.",
      wikiLink: "https://en.wikipedia.org/wiki/Diwali",
      VID: "XMh407flQlA",
    },
    {
      name: "Dewali",
      img: "./Images/Events/dewali.jpg",
      about: "Celebrate Diwali in Ayodhya with caution and awareness, as the festival of lights symbolizes the triumph of light over darkness and good over evil.",
      wikiLink: "https://en.wikipedia.org/wiki/Diwali",
      VID: "KNDSnosy04o",
    },
    {
      name: "Ram Vivah",
      img: "./Images/Events/ramvivah.jpg",
      about: "Witness the divine marriage of Lord Rama and Sita during the Ram Vivah ceremony in Ayodhya, symbolizing the union of two souls bound by love and righteousness.",
      wikiLink: "https://en.wikipedia.org/wiki/Ramayana",
      VID: "-rtiJCrmupk",
    },
    {
      name: "Saryu Aarti.",
      img: "./Images/Events/saryuaarti.jpeg",
      about: "Participate in the sacred ritual of Sarayu Aarti in Ayodhya, where devotees offer prayers and lamps to the Sarayu River, seeking blessings and purification.",
      wikiLink: "https://en.wikipedia.org/wiki/Sarayu",
      VID: "hb_jsoDMhIo",
    },
    {
      name: "Ram Navmi.",
      img: "./Images/Events/ramnavmi.webp",
      about: "Celebrate the auspicious occasion of Ram Navami in Ayodhya, commemorating the birth of Lord Rama, the seventh incarnation of Lord Vishnu, with prayers, bhajans, and processions.",
      wikiLink: "https://en.wikipedia.org/wiki/Rama_Navami",
      VID: "oVcppkRy2VE",
    },
    {
      name: "Kartik Purnima.",
      img: "./Images/Events/kartikpurnima.jpg",
      about: "Partake in the festivities of Kartik Purnima in Ayodhya, celebrated on the full moon day of the Hindu lunar month of Kartik, with rituals, holy baths, and seeking spiritual blessings.",
      wikiLink: "https://en.wikipedia.org/wiki/Kartik_Purnima",
      VID: "NVhp4ce3Qx8",
    }
  ];

  return HelpData;
}

export default HelpFullData;
